import { render, staticRenderFns } from "./IntegrityPhoneNumberInput.vue?vue&type=template&id=a8f577b2&scoped=true&"
import script from "./IntegrityPhoneNumberInput.vue?vue&type=script&lang=ts&"
export * from "./IntegrityPhoneNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrityPhoneNumberInput.vue?vue&type=style&index=0&id=a8f577b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f577b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
